import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTVenueDrinkHistory from "../page/VTVenueDrinkHistory";

export default function LandingVenueDrinkHistory({page}) {
    return (
        <>
            <Header headerType="AdminDrinkPayOnly"/>
            <VTVenueDrinkHistory/>
            <Footer/>
        </>
    );
}